const ReferralFooter = () => {
  return (
    <footer>
      <section className="footer">
        <div className="bottom">
          ЛЕНДЛОРД ™<span>1994-{new Date().getFullYear()}</span>
        </div>
      </section>
    </footer>
  );
};

export default ReferralFooter;
